import React from 'react';
import './Maintenances.scss';
import PersonalizationContainer from '../../containers/PersonalizationContainer';
import NavigationBar from '../NavigationBar';
import { withRouter } from 'react-router-dom';
import Currency from '../Currency';
import bem from '../../utils/bem';
import { StyleRoot } from 'radium';
import { ANIMATIONS } from '../../utils/constants';
import Skeleton from 'react-loading-skeleton';
import Icon from './SVG/Icon';
import { useQuery } from '../../utils/hooks';
import ExtrasActualizar from '../Extras/ExtrasActualizar';
import Empty from '../Extras/Empty';

// function useQuery() {
//   return new URLSearchParams(useLocation().search);
// }

const Maintenances = ({ match, personalization, pickMaintenance }) => {
  const query = useQuery()
  const type = query.get('back');

  const { tipo, modelo, version, anio, color } = match.params;

  const loading = (
    <>
      <Skeleton height={10} width={52} />
      <Skeleton height={20} width={62} />
      <hr />
      <Skeleton height={10} width={82} />
      <Skeleton height={10} width={120} />
      <hr />
      <Skeleton width={"100%"} height={50}/>
    </>
  );
  const isEmpty = !personalization.isLoading && personalization.isReady && (personalization?.data?.maintenances || []).length === 0;

//  Funcion para cambiar la palabra ¨anos¨ por años.
  const replaceAnosWithAnios = text => {
    return text.replace(/anos/g, 'años');
  };

  return (
    <PersonalizationContainer
      title="MANTENIMIENTO"
      subTitle="Consentí y cuidá tu nuevo chuzo con nuestros planes de mantenimiento certificado. ¡Agregalo ya!"
    >
      <div className="maintenances">
        <div className="extras__navigation">
          <NavigationBar
              back={`/${tipo}/${modelo}/${version}/${anio}/${color}/accesorios/`}
              next={`/${tipo}/${modelo}/${version}/${anio}/${color}/seguros/`}
          />
        </div>
          <div className="title-wrapper" style={{marginTop: '2.11rem'}}>
            <h6 className="title-button color">NUESTROS MANTENIMIENTOS</h6>
          </div>
          {personalization.isLoading ? (
            <div className="maintenances-options" >
              {[1,2,3].map(x => (
                <div className="maintenances-options__item maintenances-options__item--loading" key={x}>
                  {loading}
                </div>
              ))}
            </div>            
          ):(
            <StyleRoot>
              
              {!isEmpty && <div className="maintenances-options" style={ANIMATIONS.fadeIn}>
                {personalization?.data?.maintenances.map(m => {
                  return (
                    <button className={bem('maintenances-options__item', {
                      active: m.selected
                    })} 
                    onClick={() => {
                      pickMaintenance(tipo, modelo, version, anio, color, m.id, !m.selected)
                    }}
                    key={m.id}>
                        <span className="icon">
                          <Icon />
                        </span>
                        <span className="km">{m.km} Km</span>
                        <span className="currency"><Currency value={m.precio} />*</span>
                        <hr/>
                        <span className="year">{m.anios} años</span>
                        <span className="disclaimer">*Aplican Restricciones</span>
                        <hr/>
                        <span className="restriccion">{replaceAnosWithAnios(m.descripcion)}</span>  
                    </button>
                  )
                })}
              </div>}
              {isEmpty && <Empty bottomMargin message="En este momento no tenemos mantenimientos para este vehículo"/>}
              <ExtrasActualizar type={type} tipo={tipo} modelo={modelo} version={version} anio={anio} color={color} />
            </StyleRoot>
          )}
      </div>
    </PersonalizationContainer>
  );
};

export default withRouter(Maintenances);
